export default __webpack_public_path__ + "static/media/about-background-chords.0ee27724.svg";